module.exports = __webpack_public_path__ + "media/conversa/logoConversaIco-3034a5c6.png";